import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const defaultValUiNodeSpec: NodeSpec<NodeCfg<'defaultVal'>> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'input', 'output' ],
    }),
    cfg: () => ({ id: getUID(), kind: 'defaultVal', disabled: false }),
    controls: () => ({}),
    inputs: nodeCfg => ({
        defaultValue: {
            controlOpts: defineControlOpts({
                cfg: {
                    kind: 'varValue',
                    label: 'Default',
                },
                on: { 'update:value': defaultControlUpdateValueHandler },
                value: nodeCfg.socketDefaults?.inputs?.defaultValue,
            }),
            socket: 'varValue',
            label: 'Default Value',
        },
        input: { socket: 'varValue', label: 'Input' },
    }),
    kindLabel: 'Default Value',
    nodeCategory: 'variable',
    outputs: () => ({ output: { socket: 'varValue', label: 'Output' } }),
    validator: () => true,
};
